module.exports = __webpack_public_path__ + "img/Cancel.3d6f0df3.svg";